import React, { useEffect, useState, useRef } from 'react';
import { TileContainer } from "@vds/tiles";
import { Body, Micro, Title } from '@vds/typography';
import './CourseCards.scss';
import { Icon } from '@vds/icons';
import { ButtonIcon } from '@vds/button-icons';
import { TextLink } from '@vds/buttons';
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { contentClick } from '../../../common/Analytics/GAWrapper';
import ResourceTag from '../ResourceTag/resourceTag';
import { getImageToBeRendered, getWithExpiry, navigateUsingLanguage, getSuggestionData } from '../../../utility/utils';
// import { isMobile, isTablet, isDesktop } from 'react-device-detect';
import { useParams, useLocation } from 'react-router-dom';
import TimeoutImage from '../TimeoutImage.jsx';

const CourseCardComponent = (props) => {
  const { topicType } = useParams();
  const { renderType=null,imgPath=null, data, type, resourseType, inPersonEventCxData, isInPersonEvent,sectionKey } = props;
  const imgFormat = useSelector((state) => state?.Aem?.imgFormat) ?? 'avif';
  const errorCount = useRef(0);

  // Custom device detection
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 767);
      setIsTablet(width >= 768 && width <= 1023);
      setIsDesktop(width >= 1024);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const location = useLocation();
 const isResultsRoute = location?.pathname?.includes('/results');
   const isCategoryRoute = location?.pathname?.includes('/category');
  const wrapperClass = isResultsRoute ? 'resultsCard' : isCategoryRoute ? 'categoryCard' : 'secondaryCourceCard secondaryContainerCrseCard';
  const aemQuickTipsAdditionalData = useSelector((state) => state.Aem?.quickTipData?.additionalData);
  const registerAemData = useSelector((state) => state.Aem.registerData);
  const userLanguage = localStorage.getItem("lng")
  const screenType = isDesktop ? "desktop" : isTablet ? "tablet" : isMobile ? "mobile" : "desktop";
  const modifiedType = isInPersonEvent ? "inPersonEvents" : resourseType ? resourseType : type && type !== "myLibrary" && type !== "results" ? type : data?.format === "Course" ? "courses" : data?.format === "Event" ? "events" : data?.format === "Learning Path" ? "learningpath" : "quickTips"
  const resourseId = modifiedType === "quickTips" ? data?.courseId : data?.courseId?.split(":")?.[1];
  const section = modifiedType === "courses" ? "categoryCourses" : modifiedType === "events" ? "categoryEvents" : modifiedType === "quickTips" ? "categoryquickTips" : modifiedType === "myLibrary" ? "categoryMyLibrary" : "categoryLps";
  const renditionType = topicType ? topicType?.replace(/[\s-]+/g, "")?.toLowerCase() + "_" + modifiedType : section;
  const [imageUrl, setImageUrl] = useState('');
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [imgSrc, setImgSrc] = useState(props.imgPath);

  const { t } = useTranslation();
  const suggestions = getSuggestionData();
  let courseTags = [];
  for (let item in suggestions?.courses) {
    if (item === data?.courseId) {
      courseTags = suggestions?.courses[item]?.tags || []; //course topics
    }
  }

  if (registerAemData &&
    registerAemData.registerModule &&
    registerAemData.registerModule.topics &&
    courseTags != null) {
    courseTags = courseTags.filter(item => registerAemData.registerModule.topics.filter(topicItem => topicItem.label === item).length > 0);
  }


  // useEffect(() => {
  //   const img = new Image();
  //   img.src = defaultImageUrl
  //   img.onload = () => {
  //     setImageUrl(defaultImageUrl)
  //   }
  //   img.onerror = () => {
  //     setImageUrl(data?.lmsImage ?? data?.desktopImage);
  //   };
  // }, [props]);
  
  // useEffect(() => {
  //   const loadImage = async () => {
  //     setIsImageLoading(true);
  //     setImageUrl('');
  //     try {
      
  //       // http://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/course_details/en/preview/images/14072565.avif

  //   const primaryImageUrl = getImageToBeRendered(renditionType, screenType, modifiedType, userLanguage, resourseId, data?.desktopImage);
  //       if (primaryImageUrl && primaryImageUrl.trim() !== "") {
  //         const img = new Image();
  //         img.src = primaryImageUrl;
  //         await new Promise((resolve, reject) => {
  //           img.onload = resolve;
  //           img.onerror = reject;
  //           setTimeout(reject, 2000);
  //         });
  //         setImageUrl(primaryImageUrl);
  //       } else {
  //         throw new Error('Primary image URL is empty');
  //       }
  //     } catch (error) {
  //       const fallbackUrl = data?.desktopImage || data?.lmsImage;
  //       if (fallbackUrl && fallbackUrl.trim() !== "") {
  //         setImageUrl(fallbackUrl);
  //         try {
  //           const fallbackImg = new Image();
  //           fallbackImg.src = fallbackUrl;
  //           await new Promise((resolve, reject) => {
  //             fallbackImg.onload = resolve;
  //             fallbackImg.onerror = reject;
  //             setTimeout(reject, 2000);
  //           });
  //           setImageUrl(fallbackUrl);
  //         } catch {
  //           setImageUrl('');
  //         }
  //       } else {
  //         setImageUrl('http://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/course_details/en/preview/images/14072565.avif');
  //       }
  //     } finally {
  //       setIsImageLoading(false);
  //     }
  //   };
  //   loadImage();
  // }, [data?.desktopImage, data?.lmsImage, renditionType, screenType, modifiedType, userLanguage, resourseId, data?.courseId]);

  // testing code
useEffect(() => {
    let isActive = true;
      setIsImageLoading(true);
      if (renderType === "category") {
        //setImageUrl(imgPath || '');
        setIsImageLoading(false);
        return;
      }
    console.log('^^ async render;renderType,imgPath',renderType,imgPath)


    // Resolve the primary image URL once. The browser then streams/decodes the
    // image natively via the <img> tag (with lazy loading) instead of being
    // pre-downloaded with a blocking Image() request, which reduces load time.
    getImageToBeRendered(renditionType, screenType, modifiedType, userLanguage, resourseId, data?.desktopImage, imgFormat, sectionKey)
      .then((primaryUrl) => {
        if (!isActive) return;
        if (primaryUrl && primaryUrl.trim() !== "") {
          setImageUrl(primaryUrl);
        } else {
          setImageUrl(data?.lmsImage || data?.desktopImage || '');
        }
      })
      .catch(() => {
        if (!isActive) return;
        setImageUrl(data?.lmsImage || data?.desktopImage || '');
      });

    return () => {
      isActive = false;
    };
  }, [
    data?.desktopImage,
    data?.lmsImage,
    renditionType,
    screenType,
    modifiedType,
    userLanguage,
    resourseId,
    data?.courseId,
    renderType,
    imgPath,
    imgFormat,
    sectionKey,
  ]);

  //Duration conversion for language
  const getTimeInLanguage = (time) => {
    if(!time.includes('Event full')){
    time = time?.replace('minutes remaining', t('minutes remaining'));
    time = time?.replace('minutes', t('minutes'));
    time = time?.replace(/(\d+:\d+)\s?(am|pm)/gi, '$1 $2').replace(/(\d+):00\s?(am|pm)/gi, '$1 $2').replace(/-.*/, '');
    }
    return time;
  };

  const handleClick = () => {
    if (props?.data?.format === ('Course' || 'Curso' || 'course' || 'curso')) {
      contentClick(
        props?.data?.label,
        window.location.host + `/course-details/${props.data.courseId}`,
        courseTags?.filter(Boolean)?.sort()?.map((tag) => t(tag))?.slice(0, 4)?.join(', ')
      );
    }
    window.scrollTo(0, 0);
    navigateUsingLanguage(`/course-details/${props?.data?.courseId}`)
  }
    // Primary image source coming from the parent (or the async-resolved url).
  const primaryImageUrl = renderType === "category" ? (imgPath || '') : imageUrl;
  // Fallback used only if the primary image fails to load / is an invalid url.
  const fallbackImageUrl = data?.lmsImage || data?.desktopImage || '';
  const [useFallbackImage, setUseFallbackImage] = useState(false);
  // Whenever the primary source changes, retry it before falling back again.
  useEffect(() => {
    setUseFallbackImage(false);
  }, [primaryImageUrl]);
  const resolvedImageUrl = useFallbackImage ? fallbackImageUrl : primaryImageUrl;
  const handleError = () => {
    if (errorCount.current === 0) {
      errorCount.current += 1;
      setImgSrc(data?.lmsImage || data?.desktopImage || ''); // Attempt 1: Try fallback
    } else {
      setImgSrc(null); // Attempt 2+: Clear to prevent loop (renders alt text)
    }
  };

  return (
    <TileContainer
      ariaLabel={props?.data?.label?.slice(0, 72)}
      padding='0px'
      // aspectRatio='3:4'// changed to 3:3.8 from 3:4.1 only for path desc
      aspectRatio='auto'
      backgroundColor="white"
      showBorder={false}
      showDropShadow={true}
      tabIndex={-1}
      onClick={e => {
        if (props?.data?.format === ('Course' || 'Curso' || 'course' || 'curso')) {
          contentClick(
            data?.label,
            window.location.host + `/course-details/${data.courseId}`,
            courseTags?.filter(Boolean)?.sort()?.map((tag) => t(tag))?.slice(0, 4)?.join(', ')
          );
        }
        window.scrollTo(0, 0);
        navigateUsingLanguage(`/course-details/${props?.data?.courseId}`)
      }}
    >
    <div className= {wrapperClass}>
        <div className='image-icons'>
          {isInPersonEvent ?
            (props?.data?.metroArea && <ResourceTag text={props?.data?.metroArea} isInPersonEvent={isInPersonEvent} />) :
            (props?.data?.tag && <ResourceTag text={t(props?.data?.tag)} />)
          }
          {props?.data?.showBookmarkIcon &&
            <span className='ml-auto' role='button'>
              <ButtonIcon
                kind="lowContrast"
                size="small"
                surfaceType="media"
                renderIcon={(props) => <Icon name="bookmark" {...props} />}
              />
            </span>
          }
        </div>
        <div className="image">
           {imgSrc ? (
//             <img
//               src={imgSrc}
//               alt={data?.label}
//               style={{ opacity: 0, transition: 'opacity 0.2s ease-in-out' }}
//               onLoad={(e) => { e.currentTarget.style.opacity = '1'; }}
//               referrerPolicy="no-referrer"
//               crossOrigin="anonymous"
//               onError={handleError}
//             />
              <TimeoutImage
                src={imgSrc}
                fallbackSrc={data?.lmsImage || data?.desktopImage || ''}
                timeout={1000} // Custom timeout in ms
                alt={data?.label}
                style={{ opacity: 0, transition: 'opacity 0.2s ease-in-out' }}
                onLoad={(e) => { e.currentTarget.style.opacity = '1'; }}
              />
          ) : (

            <img
              src={resolvedImageUrl}
              alt={data?.label}
              loading="lazy"
              decoding="async"
              onLoad={() => setIsImageLoading(false)}
              onError={handleError}
            />
          )}
        </div>
        <div className="description pa-4X ">
          <div className='label mb-3X sm-mb-2X'>
            {isInPersonEvent ?
              (<Micro>
                <div className='course-label' aria-label={inPersonEventCxData?.ipEventModuleTxts?.inpersonEvtTxt}>
                  <b>{inPersonEventCxData?.ipEventModuleTxts?.inpersonEvtTxt}</b>
                </div>
              </Micro>) : (<Micro>
                <div className='course-label' aria-label={props?.data?.resourceType}>
                  {props?.data?.format === "Quick Tip" ? <b>{aemQuickTipsAdditionalData?.qtcardtxt}</b> : <b>{t(props?.data?.format)}</b>}
                  {props?.data?.resourceType &&
                    <span className='dot-wrap'></span>}
                  {props?.data?.format === "Quick Tip" ? <span className=''>{props?.data?.resourceType}</span> : <span className=''>{t(props?.data?.resourceType)}</span>}

                </div>
              </Micro>)}
          </div>
          <div className="title-label label mb-3X sm-mb-2X" aria-label={props?.data?.label}>
            <Title bold={false} color='#000000' size='medium'> {data?.label}</Title>
           {/* <Title bold={false} color='#000000' size='medium'>
          {data?.label ? (data?.label?.length >= 72 ? `${data.label.slice(0, 72)}...` : data.label) : ''}
          </Title> */}
          </div>
          <div className="durations mt-auto">
          <div className='textarea'>
            <div className="duration-text"  aria-label={props?.data?.dateAndTimeValue}>
              {props?.data?.duration?.preTextIcon && 
              <span className='mr-1X mb-1X'>
              <Icon
                name={props?.data?.duration?.preTextIcon ? props?.data?.duration?.preTextIcon : "calendar"}
                size="small"
                color='#716F6D'
              /> </span>}
              {props.data?.duration?.preText && (<Micro
                size="small"
                color='#716F6D'
                bold={true}
                primitive="span">
                <span className='mr-1X'> {t(props?.data?.duration?.preText)}</span>
              </Micro>)}
              {props?.data?.duration?.icon && props?.data?.duration?.icon != "" && <span className='mr-1X mb-1X'><Icon
                // name={isInPersonEvent ? "calendar" : props?.data?.duration?.icon ? props?.data?.duration?.icon : "count-down"}
                name={ (isInPersonEvent || props?.data?.format === "Event") ? props?.data?.duration?.icon ?? "calendar": "timer"}
                size="small"
                color={!isInPersonEvent ? props?.data?.duration?.color : '#716F6D'}
              /> </span>}
              {props.data?.dateAndTimeValue && (<Micro
                size="small"
                color='#716F6D'
                bold={true}
                primitive="span">
                <span className='mr-1X'>{t(getTimeInLanguage(props?.data?.dateAndTimeValue))}</span>
              </Micro>)}
              {isInPersonEvent && (<Micro
                size="small"
                bold={true}
                color={props?.data?.duration?.color}
                primitive="span">
                <><span className='ml-1X mr-1X'>{props?.data?.cardDate}</span>{props?.data?.isFinalDayEnrollment && <span className="ml-1X" style={{color: props?.data?.additionalStatus?.color ?? null}}>{inPersonEventCxData?.ipEventModuleTxts?.enrollLstDateMsg ?? null}</span>}</>
              </Micro>)}
              {!isInPersonEvent &&<Micro
                size="small"
                color={props?.data?.duration?.color}
                bold={data?.duration?.preText ? false : true}
                primitive="span">
                {props?.data?.format === "Quick Tip" ? <span className="ml-1X">{getTimeInLanguage(props?.data?.duration?.time)}</span> : <span className="">{t(getTimeInLanguage(props?.data?.duration?.time))}</span>}
              </Micro>}
              {props.data?.duration?.extLink && (
                <TextLink
                  type='inline'
                  size='small'
                  color={props?.data?.duration?.color}
                />)}
                {/* {props.data?.duration?.preText && (<Micro
                  size="small"
                  color='#6F7171'
                  bold={true}
                  primitive="span">
                  <span className='mr-2X'> {t(props?.data?.duration?.preText)}</span>
                </Micro>)}
                {props?.data?.duration?.icon && props?.data?.duration?.icon != "" && <Icon
                  name={isInPersonEvent ? "calendar" : props?.data?.duration?.icon ? props?.data?.duration?.icon : "count-down"}
                  size="small"
                  color={!isInPersonEvent ? props?.data?.duration?.color : ''}
                />}
                {props.data?.dateAndTimeValue && (<Micro
                  size="small"
                  color='#6F7171'
                  bold={true}
                  primitive="span">
                  <span className='mr-1X'>{t(getTimeInLanguage(props?.data?.dateAndTimeValue))}</span>
                </Micro>)}
                {isInPersonEvent && (<Micro
                  size="small"
                  bold={true}
                  color={props?.data?.duration?.color}
                  primitive="span">
                  <><span className='mr-1X'>{props?.data?.cardDate}</span>{props?.data?.isFinalDayEnrollment && <span className="ml-1X" style={{ color: props?.data?.additionalStatus?.color ?? null }}>{inPersonEventCxData?.ipEventModuleTxts?.enrollLstDateMsg ?? null}</span>}</>
                </Micro>)}
                {!isInPersonEvent && <Micro
                  size="small"
                  color={props?.data?.duration?.color}
                  bold={true}
                  primitive="span">
                  {props?.data?.format === "Quick Tip" ? <span className="ml-1X">{getTimeInLanguage(props?.data?.duration?.time)}</span> : <span className="ml-1X">{t(getTimeInLanguage(props?.data?.duration?.time))}</span>}
                </Micro>}
                {props.data?.duration?.extLink && (
                  <TextLink
                    type='inline'
                    size='small'
                    color={props?.data?.duration?.color}
                    onClick={e => alert('TextLink clicked')}>
                    <span className="ml-1X">{props?.data?.duration?.extLink?.text}</span>
                  </TextLink>)} */}
              </div>

              <div>
                <ButtonIcon
                  role="link"
                  tabIndex={0}
                  ariaLabel={`${props?.data?.ariaLabel ? props?.data?.ariaLabel?.replace('undefined', '') : ""} ${props?.data?.label} ${t(props?.data?.format)}`}
                  kind="ghost"
                  size={isMobile ? "small" : "large"}
                  renderIcon={(props) => <Icon name="right-arrow" {...props} />}
                  onClick={() => handleClick()}
                />
              </div>
            </div>
          </div>
        </div>
        {props?.data?.shortDesc && <div className="pv-4X ph-6X sm-pa-4X path-des bg-monarch">
          <Icon name='ideas-solutions' size="small"></Icon>
          <Body size='small' bold>
            <div className='pl-1X' >
              {props?.data?.shortDesc?.slice(0, 72)}
            </div>
          </Body>
        </div>}

      </div>

    </TileContainer>
  );
};

export default CourseCardComponent;
